import { action, observable, makeObservable } from 'mobx';
import ProjectStore from './ProjectStore';

class Store {
  buildings = new Map();

  constructor() {
    makeObservable(this, {
      buildings: observable,
      addBuilding: action,
      removeBuilding: action,
      create: action
    });
  }

  addBuilding(id, building) {
    this.buildings.set(id, building);
  }

  removeBuilding(id) {
    this.buldings.delete(id);
  }

  create = async name => {
    const params = {
      name,
      buildings: this.buildings.values()
    };

    await ProjectStore.createProject(params);
  };
}

const store = new Store();
export default store;
